<template>
  <div>
  <div id="homePage-2" v-if=" this.$i18n.locale == 'zh'">
    <div class="part-title">
      <h3>{{msg}}</h3>
      <p>星球数据为企业数字化保驾护航</p>
    </div>
<ul>
<li><a :style="linkStyle" href="http://vajeaf.qc.to:5678" target="_blank">AI集成的工作流自动化平台</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:9217" target="_blank">支付(运营平台登录)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:9218" target="_blank">支付(商户端)</a></li>
        <li><a :style="linkStyle" href="http://vajeaf.qc.to:9219" target="_blank">支付(代理商端)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:9220" target="_blank">支付(门店端)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:9221" target="_blank">支付(集团端)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:8014" target="_blank">商城(手机端)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:8013" target="_blank">商城(后台管理)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:1888" target="_blank">物业保安管理</a></li>
       <li>制造业，流程审批平台</li>      
       <li>物联网，RFID标签、AGV自动盘点、西门子PLC、OpenWrt控制</li>
       <li>更多部署中...</li>

</ul>
  </div>
  <div id="homePage-2" v-if=" this.$i18n.locale == 'en'">
    <div class="part-title">
      <h3>Solutions</h3>
      <p>Star Data provides digital protection for enterprises</p>
    </div>
<ul>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:5678" target="_blank">AI-native platform</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:9217" target="_blank">pay(manager)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:9218" target="_blank">pay(merchant)</a></li>
        <li><a :style="linkStyle" href="http://vajeaf.qc.to:9219" target="_blank">pay(agent)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:9220" target="_blank">pay(store)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:9221" target="_blank">pay(group)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:8014" target="_blank">mall(mobile)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:8013" target="_blank">mall(admin)</a></li>
       <li><a :style="linkStyle" href="http://vajeaf.qc.to:1888" target="_blank">Property Security Management</a></li>
       <li>Manufacturing platform</li>
       <li>LoT, RFID tags, AGV automated inventory, Siemens PLC, OpenWrt control</li>
       <li>More deployments in progress...</li>

</ul>
  </div>
</div>
</template>

<script>
export default {
  name: 'PageTwo',
  data () {
    return {
      msg: '解决方案',
      linkStyle: {
        color: 'blue',
        textDecoration: 'underline'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#homePage-2 {
  width: 100%;
  height: 100%;
  padding-top: 120px;
  background: url("~assets/img/banner/bg_diandian.png") center no-repeat,
              linear-gradient(to right,#fff 0,#f1f2f6 100%);
  background-size: cover;
}
.part-title {
  position: relative;
  width: 100%;
  margin-bottom: 65px;
  -webkit-transition: all 1s;
  transition: all 1s;
  text-align: center;
  h3 {
    margin-bottom: 10px;
    font-size: 30px;
    font-weight: 700;
    color: #072c69;
  }
  p {
    font-size: 16px;
    color: #acadb3;
  }
}
ul{
    font-size: 20px;
    margin: 2rem auto;
    text-align: left;
    display: inline-block;
    list-style-type: none;
    line-height: 40px;
  }
</style>
